import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../../utils/types";
import {
  selectUserDetailsStatistics,
  selectUserLoading,
} from "../../../../../redux/educator/selector";
import { getUserDetailsStatistics } from "../../../../../redux/educator/actions";

const mapStateToProps = (state: StateType) => ({
  userModule: selectUserDetailsStatistics(state),
  loading: selectUserLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getUserDetailsStatistics,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
